<template>
  <div>
    <v-dialog persistent v-model="NewAppDialog" max-width="400">
      <v-card max-height="650px">
        <v-card-title>
          {{NewAppDialogTitle}}
          <!-- {{NextStep}} -->
          <v-spacer>
            </v-spacer><v-avatar
                            color="primary lighten-2"
                            class="subheading white--text"
                            size="24"
                            v-text="newappstep"
                        ></v-avatar>
            <v-icon @click="ToggleNewAppDialog()" color="red" class="soloactionicon">
              mdi-close</v-icon>
        </v-card-title>
        <v-card-subtitle>
          {{NewApp && NewApp.Plugins ? NewApp.Plugins.length : ''}} Selected
        </v-card-subtitle>
        <v-card-text>
         <v-window v-model="newappstep">
      <v-window-item :value="1">
        <v-card-text>
          <v-text-field
            label="App Name"
            v-model="NewApp.Name"
          ></v-text-field>
           <span class="text-caption grey--text text--darken-1">
            This is the name you will use to reference your App
          </span>
           <v-text-field
            label="App Icon"
            v-model="NewApp.Icon"
          ></v-text-field>
          <v-icon>{{NewApp.Icon}}</v-icon>
          <span class="text-caption grey--text text--darken-1">
            This is Icon that will appear in the navigaiton
          </span>
        </v-card-text>
      </v-window-item>
      
      <v-window-item :value="2">
        <v-card-text>
          <!-- At this point and time the entities are assigned with their new id's, they are done.  -->
            <RAPluginCarousel :AppisDarkMode="AppisDarkMode" class="my-3" :GuideList="RAPluginsMatched(['App'])" :tab="systemguideelmnt"
            :ListPreviewOnly="false" :Squished="true" :PluginPicker="true" @PickPlugin="PickPlugin"
              />
        </v-card-text>
      </v-window-item>
        <v-window-item :value="3">
        <v-card-text>
          <!-- At this point and time the entities are assigned with their new id's, they are done.  -->
            <RAPluginCarousel :AppisDarkMode="AppisDarkMode" class="my-3" :GuideList="RAPluginsMatched(['Database Builder','DBB','Social Network Builder','SNB'])" :tab="systemguideelmnt"
            :ListPreviewOnly="false" :Squished="true" :PluginPicker="true" @PickPlugin="PickPlugin"
              />
        </v-card-text>
      </v-window-item>
      <v-window-item :value="4">
        <v-list dense v-for="table in ConfigRequiredImmediateTables" :key="table.itemObjKey">
          <v-list-item dense>
            {{table.Entity_Type.Name}}
          </v-list-item>
          <v-list-item dense class="settingsfont">
            <v-text-field
            :label="'Table Name (Multiple '+table.DisplayName+')'"
            v-model="table.DisplayName"
          ></v-text-field>
          </v-list-item>
          <v-list-item dense class="settingsfont">
            <v-text-field
            :label="'Single (1 '+table.SingleName+')'"
            v-model="table.SingleName"
          ></v-text-field>
          </v-list-item>
          <v-list-item dense class="settingsfont">
            <v-text-field
            label="Icon"
            v-model="table.Table_Icon"
          ></v-text-field>
          <v-icon>{{table.Table_Icon}}</v-icon>
          </v-list-item>
          <v-list-item dense class="settingsfont">
            <v-text-field
            :readonly="table.Entity_Type.Name === 'Scheduled Booking'"
             :label="table.Entity_Type.Name === 'Scheduled Booking' ? 'Primary Field Name (Cannot Change)' : 'Primary Field Name'"            
            v-model="table.Primary_Field_Name"
          ></v-text-field>
          </v-list-item>
          <v-list-item dense class="settingsfont">
            <v-select
            :label="table.Security_Structure && table.Security_Structure.Name === 'Warehouse' ? 'Security Structure (Cannot Change)' : 'Security Structure'" item-text="Name"
            :items="EntitySecurityOptions" return-object :readonly="table.Security_Structure && table.Security_Structure.Name === 'Warehouse'"
            v-model="table.Security_Structure"
          ></v-select>
          </v-list-item>
        </v-list>
      </v-window-item>
      <!-- <v-window-item :value="5">
        <v-list dense v-for="table in ConfigRequiredInstallingTables" :key="table.itemObjKey">
          <v-list-item dense>
            {{table.Entity_Type.Name}}
          </v-list-item>
          <v-list-item dense class="settingsfont">
            <v-text-field
            :label="'Table Name (Multiple '+table.DisplayName+')'"
            v-model="table.DisplayName"
          ></v-text-field>
          </v-list-item>
          <v-list-item dense class="settingsfont">
            <v-text-field
            :label="'Single (1 '+table.SingleName+')'"
            v-model="table.SingleName"
          ></v-text-field>
          </v-list-item>
          <v-list-item dense class="settingsfont">
            <v-text-field
            label="Icon"
            v-model="table.Table_Icon"
          ></v-text-field>
          <v-icon>{{table.Table_Icon}}</v-icon>
          </v-list-item>
          <v-list-item dense class="settingsfont">
            <v-text-field
            label="Primary Field Name"
            v-model="table.Primary_Field_Name"
          ></v-text-field>
          </v-list-item>
          <v-list-item dense class="settingsfont">
            <v-select
            :label="table.Security_Structure && table.Security_Structure.Name === 'Warehouse' ? 'Security Structure (Cannot Change)' : 'Security Structure'" item-text="Name"
            :items="EntitySecurityOptions" return-object :readonly="table.Security_Structure && table.Security_Structure.Name === 'Warehouse'"
            v-model="table.Security_Structure"
          ></v-select>
          </v-list-item>
        </v-list>
      </v-window-item> -->
      <v-window-item :value="5">
        Probably would be best to have overview and shit, but for now just add app tog et going testing concept
      </v-window-item>
    </v-window>

    <v-divider></v-divider>

    <v-card-actions>
      <v-btn
        :disabled="newappstep === 1"
        text
        @click="newappstep--"
      >
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn dark v-if="CanSkipAppStep"
        color="warning"
        depressed
        @click="AdvanceNewappDialog()"
      >
        Skip
      </v-btn>
      <v-btn v-if="newappstep !== 5"
        color="primary"
        depressed
        @click="AdvanceNewappDialog()"
      >
        Next
      </v-btn>
      <v-btn v-if="newappstep === 5"
        color="primary"
        depressed
        @click="PrepareNewApp()"
      >
        Install
      </v-btn>
    </v-card-actions>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-layout  column  v-if="MiniView"
            style="z-index:7;position: fixed;bottom: 60px;left: 30px;z-index:50;" >
            <v-btn icon x-large @click="ToggleSiteDialog()"><v-icon  color="links" x-large>mdi-menu</v-icon></v-btn>							
        </v-layout>
         <Callout  :PageHeadersFont="'Raleway'" :PageContentFont="'Raleway'"									
        :PageHeadersFontSize="30"	:style="BuilderHelperStyleandPosition" v-if="ViewBuilderHelper"						
        :tab="AppBuilderElement" @OpenDialog="OpenDialog" @ActionBtnMethod="ActionBtnMethod"
      />
    <!-- could actually start building apps on Ra this way, limiting to Systemconfig makes it difficult, if route was systembuilder etc -->
     <v-app-bar dark width="100%" id="appbuildermainnavbar" :class="$vuetify.theme.dark ? 'RAWebBtnGraddark' : 'RAWebBtnGradlight'"
     style="top:0px;position: fixed;z-index:151;font-variant-caps: all-petite-caps;" v-if="!$route.meta.DataSingleBuilder || $route.name === 'SystemConfig'">
       <v-list width="100%" dense class="transparent">
        
         <v-list-item dense>
           <v-menu nudge-right="30" 								
                :close-on-content-click="false"                            									
                transition="scale-transition"                            									
                >									
                <template v-slot:activator="{ on }">	
                <v-icon  
                v-on="on" 
                >
                  mdi-star
                </v-icon>
                </template>
                <v-card flat width="200">
                    <v-list class="settingsfont" dense >
                        <v-list-item @click="AddPageAsFavorite()">
                            <v-list-item-title v-if="!CurrentisFavorite" class="navoverline"><v-icon style="padding-right: 5px;" size="18">mdi-star-outline</v-icon>Add as Favorite</v-list-item-title>
                            <v-list-item-title v-if="CurrentisFavorite" class="navoverline"><v-icon style="padding-right: 5px;" size="18">mdi-star-off</v-icon>Remove Favorite</v-list-item-title>
                        </v-list-item>
                        <v-menu nudge-right="90"                           									
                          transition="scale-transition"                            									
                          >									
                          <template v-slot:activator="{ on }">	
                            <v-list-item v-on="on">
                              <v-list-item-title class="navoverline"><v-icon style="padding-right: 5px;" size="18">mdi-star</v-icon>My Favorites</v-list-item-title>
                          </v-list-item>
                          </template>
                          <v-list dense >
                          <v-virtual-scroll
                              :items="NavUserFavorites"
                              :height="NavUserFavorites.length > 4 ? 200 : NavUserFavorites.length*45"
                              item-height="40"                  
                            >
                            <template v-slot:default="{ item }">
                              
                              <v-list-item  class="settingsfont"
                                    :to="item.Path"
                                >          
                                <!-- <v-list-item-action>
                                <v-icon class="actionicon" color="accent">{{ item.icon }}</v-icon>
                                    
                                  </v-list-item-action>                           -->
                                    <v-list-item-title class="navoverline">{{ item.title }}</v-list-item-title>
                                </v-list-item>
                             
                            </template>
                          </v-virtual-scroll>
                           </v-list>
                        </v-menu>
                    </v-list>
                </v-card>
            </v-menu>
           <v-icon class="actionicon mx-2" @click="ToggleAppDarkMode()">
                      mdi-invert-colors
                    </v-icon>
           <v-list-item-content id="appbuilder-builderselector">
             Builder:
             <v-overflow-btn style="padding-top:15px;widht:50px;" @change="CheckBuilderRoute()"
              :items="ComputedBuilders" placeholder="Builder" v-model="SelectedBuilder"
                item-text="Name"
                  class="elevation-0 noborderoverflow"
                  dense return-object
                  >
                  <template v-slot:no-data>
                    <v-list-item>
                    You do not have any modules purchased. In the screen below you should really choose a module. 
                    </v-list-item>
                  <!-- <v-btn color="primary" @click="ProceedHelpder()">Proceed</v-btn> -->
                </template>
                  </v-overflow-btn>
           </v-list-item-content>
           
           <v-btn v-if="PluginDataBase && PluginDataBase.Social_Network_Builder && System.Social_Landing_Page && CanSocial" @click="IntranetViewToggle(true,true)" text>
              <v-icon dark>
                  mdi-repeat
                </v-icon>Switch to {{System.Social_Module_Name}}
            </v-btn>
           <v-list-item-content v-if="WebsiteBuilderView || NetworkBuilderView && !IsGroupView">
              Page:
             <v-overflow-btn style="padding-top:15px;"
              :items="ComputedSitePages" placeholder="Page" v-model="SelectedPage"
                item-text="Name" @change="EditOtherPage(SelectedPage)"
                  class="elevation-0 noborderoverflow"
                  dense return-object
                  ></v-overflow-btn>
            </v-list-item-content>
            <v-list-item-content v-if="SelectedBuilder.Name === 'App Builder'">
              App:
             <v-overflow-btn style="padding-top:15px;"
              :items="RegisteredApps" placeholder="App" v-model="SelectedApp"
                item-text="Name" @change="EditOtherApp(SelectedApp)"
                  class="elevation-0 noborderoverflow"
                  dense return-object
                  ></v-overflow-btn>
            </v-list-item-content>
            
            <v-list-item-actions v-if="SelectedBuilder && SelectedBuilder.Name === 'Website Builder'
            || SelectedBuilder && SelectedBuilder.Name === 'Social Network Builder'">
              <v-btn dark color="success white--text" @click="AssignSocialItemInteractMethod('SavePageAsIs')">
                  Save
                  <v-icon >mdi-content-save</v-icon></v-btn>
            </v-list-item-actions>
         </v-list-item>
        
       </v-list>
      </v-app-bar>
      <SuiteBuilder v-if="SuiteBuilderView" :SitePages="SitePages" :SystemPhotoLibraries="SystemPhotoLibraries" :GraphicalElements="GraphicalElements" :RegisteredApps="RegisteredApps"
    :DefaultThemes="DefaultThemes" @SetColorstoSystemColors="SetColorstoSystemColors" :GradientElements="GradientElements" :DocumentationLibraries="DocumentationLibraries"
   :System="System" :SystemEntities="SystemEntities" :SocialEntities="SocialEntities" :GroupEntities="GroupEntities" :WebFormEntities="WebFormEntities"
   @ToggleNewAppDialog="ToggleNewAppDialog"
    />
     <DocumentationLibraryBuilder v-if="DocLibBuilderView" :SitePages="SitePages" :SystemPhotoLibraries="SystemPhotoLibraries" :GraphicalElements="GraphicalElements"
    :DefaultThemes="DefaultThemes" @SetColorstoSystemColors="SetColorstoSystemColors" :GradientElements="GradientElements" :DocumentationLibraries="DocumentationLibraries"
   :System="System" :SystemEntities="SystemEntities" :SocialEntities="SocialEntities" :GroupEntities="GroupEntities" :WebFormEntities="WebFormEntities"
    />
    <WebsiteBuilderComponent v-if="WebsiteBuilderView" :SitePages="SitePages" :SystemPhotoLibraries="SystemPhotoLibraries" :GraphicalElements="GraphicalElements" :RADB="RADB"
    :DefaultThemes="DefaultThemes" @SetColorstoSystemColors="SetColorstoSystemColors" :GradientElements="GradientElements" :DocumentationLibraries="DocumentationLibraries"
   :System="System" :SystemEntities="SystemEntities" :SocialEntities="SocialEntities" :GroupEntities="GroupEntities" :WebFormEntities="WebFormEntities" @SelectPage="SelectPage"
    />
    <DatabaseBuilderComponent v-if="DBBuilderView" :SitePages="SitePages" :SystemPhotoLibraries="SystemPhotoLibraries" :GraphicalElements="GraphicalElements"
    :DefaultThemes="DefaultThemes" @SetColorstoSystemColors="SetColorstoSystemColors" :GradientElements="GradientElements" :DocumentationLibraries="DocumentationLibraries"
   :System="System" :SystemEntities="SystemEntities" :SocialEntities="SocialEntities" :GroupEntities="GroupEntities" :WebFormEntities="WebFormEntities"
    />
    <NetworkBuilderComponent v-if="NetworkBuilderView" :SitePages="SitePages" :SystemPhotoLibraries="SystemPhotoLibraries" :GraphicalElements="GraphicalElements"
    :DefaultThemes="DefaultThemes" @SetColorstoSystemColors="SetColorstoSystemColors" :GradientElements="GradientElements" :DocumentationLibraries="DocumentationLibraries"
   :System="System" :SystemEntities="SystemEntities" :SocialEntities="SocialEntities" :GroupEntities="GroupEntities" :WebFormEntities="WebFormEntities" @SelectPage="SelectPage"
    /></div>
</template>

<script>
import firebase from 'firebase';
import db from '@/main'
import axios from 'axios'
import format from 'date-fns/format'
import SuiteBuilder from '@/components/SuiteBuilder/Navigators/SuiteBuilder';	
import WebsiteBuilderComponent from '@/components/SuiteBuilder/Navigators/WebsiteBuilderComponent';	
import DatabaseBuilderComponent from '@/components/SuiteBuilder/Navigators/DatabaseBuilderComponent';	
import NetworkBuilderComponent from '@/components/SuiteBuilder/Navigators/NetworkBuilderComponent';	
import DocumentationLibraryBuilder from '@/components/SuiteBuilder/Navigators/DocumentationLibraryBuilder';	
import Callout from '@/components/WebPages/RenderComponents/InfoSheetReadOnly';
import RAPluginCarousel from '@/components/WebPages/RenderComponents/RAPluginCarousel';
export default {
    props: ['System','SystemEntities','SitePages','SocialEntities','SystemPhotoLibraries','GroupEntities','GraphicalElements','DefaultThemes','GradientElements','DocumentationLibraries',
    'RADB','RAApp'],
    components: {SuiteBuilder,WebsiteBuilderComponent,DatabaseBuilderComponent,NetworkBuilderComponent,DocumentationLibraryBuilder,Callout,RAPluginCarousel},
    data() {
        return {
          DefaultMemberGroup: {
                Name: 'System Administrators',
                Description: 'Default System Administrators Group - Non Editable',
                SecurityRoles: ['System Admin'],
                AdditionalProperties: {
                    MonetizationOfficer: false,
                    IsEagleViewer: false,
                    BusinessProfileAdmin: false,
                    SiteContentAdmin: false,
                    IsGuestUser: false,
                    IsSystemAdmin: true,
                    IsTeamActivityManager: false,
                    CanInviteUsers: true,
                    InviteGroups: [],
                    CanExport: true,
                    CanImport: true,
                },  
                CanSocial: true,              
                SocialRestrictions: false,
                SocialChannels: [],
                CompanySocial: false,
                UserTableFilters: [],
                ActivityQueries: {},
                ModerationPermissions: [],
                // DBNavList: '',
            },
          systemguideelmnt: {			
              HideGuidesCarousel: false,						
                RowColor: '#00ffff',									
                Name: 'System Guide',									
                ShowComponents: true,									
                Icon: 'mdi-card-text',									
                Title: 'About',									
                Description: `Lorem ipsum dolor sit amet, no nam oblique veritus. Commune scaevola imperdiet`,									
                MarginTop: 0,									
                MarginBottom: 0,									
                MarginLeft: 0,									
                MarginRight: 0,		
                Elevation: 6,
                BoxTransparency: '',
                FontColor :{									
                        hex: '#000000'									
                },									
                HeaderColor: {									
                    hex: '#000000'									
                },									
                FlexXLRG:6,									
                FlexLarge: 8,									
                FlexMedium: 10,									
                FlexSmall: 12,									
                FlexXSmall: 12,									
                Cols: 12,									
            },
          EntitySecurityOptions: [{ID:1000001,Name:"Custom Roles"},{ID:1000002,Name:"Business Unit"},{ID:1000003,Name:"Warehouse"}],
          NextStep: 1,
          newappstep: 1,
          NewApp: {
            Name: '',
            Plugins: [],
            MenuItems: []
          },
          DefaultNewApp: {
            Name: '',
            Plugins: [],
            MenuItems: []
          },
          NewAppDialog: false,
          ImmediateTables: [],
          InstallingTables: [],
          HelpElmntTop: '',
          HelpElmntLeft: '',
          HelperParentElement: '',
          infoelmnt: {
            Checked: false,
            HasActionButton: true,
            ActionButtonMethod: 'AdvanceHelperMethod',
            ActionhasConfirm: true,
            ActionConfirmLabel: 'Do not Show Again',
            ActionButtonName: 'Got it',
            Fixed: true,
            BorderPosition: 'right',
            Color: 'blue',
            Elevation: 6,
            // AlertIcon: 'mdi-information',
            ColoredBorder: true,
            Width: 400,
            MarginTop: 20,
            MarginBottom: 0,
            MarginLeft: 15,
            MarginRight: 0,
            Description: `<p>Toggle the Builder to change what you are editing</p>`,
            Dense: true,
            Prominent: true,
            Justify: 'justify-end',
            ActionList: [
            ]
          },
          RecordName: '',  
          SelectedPage: '',
          SelectedApp: '',
          SelectedBuilder: '',
          Builders: [
            {Name: 'Suite Builder'},
            {Name: 'App Builder'},
            {Name: 'Website Builder'},
            {Name: 'Social Network Builder'},
            {Name: 'Database Builder'},
            {Name: 'Documentation Builder'}            
          ],
          WindowWidth: 0,
          WindowHeight: 0
        }
    },
    computed:{
      EntitiesArray(){
            return this.$store.state.EntitiesArray
        },
      UsersArray(){
            return this.$store.state.Users
        },
        DefaultStatusField(){
            return this.System.DefaultStatusField ? 
            this.System.DefaultStatusField : 
            this.$store.state.DefaultStatusField
        },
        CurrentUserProps(){
          let user = this.userLoggedIn
          let userobj = {
            Full_Name: user.Full_Name,
            Name: user.Name,
            Surname: user.Surname,
            id: user.id,
            Email: user.Email
          }
          return userobj
        },
      UsersforProperties(){
      return this.UsersArray.map(user =>{
        let userobj = {
          Full_Name: user.Full_Name,
          Name: user.Name,
          Surname: user.Surname,
          id: user.id,
          Email: user.Email
        }
        return userobj
      })
    }	,
      RegisteredApps(){
            return this.$store.state.AppsDataBase
        },
      AppsPath(){
      return this.$store.state.AppsPath
    },
      CanSkipAppStep(){
        return this.newappstep === 3 && this.NewApp.AppTemplateid || this.newappstep === 2 || this.newappstep === 3 && this.NewApp.Plugins && this.NewApp.Plugins.length > 0
      },
      NewAppDialogTitle(){
        switch (this.newappstep) {
          case 1 : return 'App Name'
          case 2 : return 'Choose Template'
          case 3 : return 'Choose Plugins'
          case 4 : return 'Configure Tables'
          case 5 : return 'Install'
          // case 6 : return 'Install'
        } 
      },
      ConfigRequiredImmediateTables(){
        return this.ImmediateTables.filter(table => {
          return !table.System_Required
        })
      },
      ConfigRequiredInstallingTables(){
        return this.InstallingTables.filter(table => {
          return !table.System_Required
        })
      },
      ViewBuilderHelper(){
        return this.AppBuilderHelperActive && typeof this.HelpElmntTop !== 'undefined' && typeof this.HelpElmntLeft !== 'undefined'
      },
      AppBuilderHelperActive(){
        return this.$store.state.AppBuilderHelperActive
      },
      AppBuilderHelperStep(){
        return this.$store.state.AppBuilderHelperStep
      },
      AppBuilderElement(){
        let helperobj = Object.assign({},this.infoelmnt)
        let description = ``
        let btnname = ''
        let method = ''
        let hasconfirm = false
        let confirmlabel = ''
        if(this.AppBuilderHelperStep === 1){
          description = `<p>Here is the Main Builder Menu that is present whenever your are in "Builder View". It remains open regardless which "Builder" (Module) you are editing. </p>`
          method = 'AdvanceHelperMethod'          
          confirmlabel = 'Do not Show Again'
          btnname = 'Got it'
          hasconfirm = true
          helperobj.Description = description
          helperobj.ActionButtonMethod = method
          helperobj.ActionhasConfirm = hasconfirm
          helperobj.ActionConfirmLabel = confirmlabel
          helperobj.ActionButtonName = btnname
        }
        else if(this.AppBuilderHelperStep === 2){
          description = `<p>The "Builder Selector" changes the "Builder" (Module) you are working on. Only purchased modules reflect as options... </p>`
          method = 'AdvanceHelperMethod'          
          confirmlabel = 'Do not Show Again'
          btnname = 'Got it'
          hasconfirm = true
          helperobj.Description = description
          helperobj.ActionButtonMethod = method
          helperobj.ActionhasConfirm = hasconfirm
          helperobj.ActionConfirmLabel = confirmlabel
          helperobj.ActionButtonName = btnname
        }
        return helperobj
      },
      AppBuilderGuideElementid(){
        if(this.AppBuilderHelperActive){
          if(this.AppBuilderHelperStep === 1){
            return 'appbuildermainnavbar'
          }
          else if(this.AppBuilderHelperStep === 2){
            return 'appbuilder-builderselector'
          }
        }
      },
      BuilderHelperStyleandPosition(){
        if(this.ViewBuilderHelper){
         let style = 'z-index:500;position: fixed;'
        style = style+'top:'+this.HelpElmntTop+'px;left:'+this.HelpElmntLeft+'px;'
        return style 
        }
        
      },
      UserisGuest(){
    return this.userLoggedIn ? this.userLoggedIn.IsGuestUser : 'undefined' 
    
  },
  ActiveMemberGroup(){
      return this.$store.state.ActiveMemberGroup
    },
      CanSocial(){
        return this.UserisGuest && !this.ActiveMemberGroup && this.System.Guests_can_Social || 
        this.ActiveMemberGroup && this.ActiveMemberGroup.CanSocial || this.userIsAdmin
      },
      PluginDataBase(){
        return this.$store.state.PluginDataBase
      },
      ComputedBuilders(){
        return this.Builders.filter(builder => {
          return this.PluginDataBase[builder.Name.split(' ').join('_')] && this.PluginDataBase[builder.Name.split(' ').join('_')].Active || builder.Name === 'Suite Builder' || builder.Name === 'App Builder' && !this.IsGroupView
        })
      },
      NoActiveModule(){
        return !this.WebsiteisActive && !this.SocialNetworkisActive && !this.DatabaseisActive && !this.DocumentationisActive
      },
      WebsiteisActive(){
        return this.$store.state.WebsiteisActive
      },
      SocialNetworkisActive(){
        return this.$store.state.SocialNetworkisActive
      },
      DatabaseisActive(){
        return this.$store.state.DatabaseisActive
      },
      DocumentationisActive(){
        return this.$store.state.DocumentationisActive
      },
      CurrentisFavorite(){
      let path = this.$route.path
      if(this.userLoggedIn && this.userLoggedIn.FavoriteLinks){
      let pathcheck = this.userLoggedIn.FavoriteLinks.find(obj => obj.Path === path)
        if(pathcheck){
          return true
        }
        else {
          return false
        }
      }
      else{
        return false
      }
    },
      UserFavorites(){
      return this.userLoggedIn && this.userLoggedIn.FavoriteLinks ? this.userLoggedIn.FavoriteLinks : []
    },
    NavUserFavorites(){
      return this.UserFavorites.map(fav => {
        let favobj = {
          title: fav.DisplayName,
          icon: '',
          Path: fav.Path,
          IsRoute: true,
          RouteBlank: false
        }
        return favobj
      })
    },
      DocumentationLibraryObj(){
            let doclibobj = this.DocumentationLibraries.find(obj => obj.id === this.$route.params.id)
            if(this.DocLibEditor && doclibobj){
                return doclibobj
            }
        },
        ActiveDocumentationLibrary(){
            return this.$store.state.ActiveDocumentationLibrary
        },
      SiteDialog(){
            return this.$store.state.SiteDialog
        },
      GroupidRoutes(){
            return this.$store.state.GroupidRoutes
        },
        GroupslugRoutes(){
            return this.$store.state.GroupslugRoutes
        },
        GroupID(){
            if(this.GroupidRoutes.includes(this.$route.name)){
                return this.$route.params.id
            }
            else if(this.$route.query && this.$route.query.GroupID){
                return this.$route.query.GroupID
            }
            else if(this.GroupslugRoutes.includes(this.$route.name)){
                return this.$route.params.slug
            }
        },
      WebFormEntities(){
        return this.SystemEntities.filter(ent => {
          return ent.EntityType && ent.EntityType.Name === 'Web Form'
        })
      },
      IsGroupView(){
        return this.$store.state.IsGroupView
    },
      BuilderView(){
      return this.$store.state.BuilderView
      },
      DocLibBuilderView(){
        return this.BuilderView && this.BuilderView.Name === 'Documentation Builder'
      },
      WebsiteBuilderView(){
        return this.BuilderView && this.BuilderView.Name === 'Website Builder'
      },
      DBBuilderView(){
        return this.BuilderView && this.BuilderView.Name === 'Database Builder'
      },
      NetworkBuilderView(){
        return this.BuilderView && this.BuilderView.Name === 'Social Network Builder'
      },
      SuiteBuilderView(){
        return !this.DocLibBuilderView && !this.WebsiteBuilderView && !this.DBBuilderView && !this.NetworkBuilderView
      },
      BuilderName(){
        return this.SelectedBuilder ? this.SelectedBuilder.Name : ''
      },
      PageName(){
        return this.SelectedPage ? this.SelectedPage.Name : ''
      },
      ComputedSitePages(){
            if(this.IsGroupView){
                return this.ActiveGroup && this.ActiveGroup.Pages ? this.ActiveGroup.Pages : []
            }
            else{
                return this.SitePages.filter(page => {
                  if(this.WebsiteBuilderView){
                    return page.PublishType === 'Public'
                  }
                  else{
                    return page.PublishType === 'Members Only'
                  }
                })
            }
        },
      PageTabsPropName(){
            if(this.$route.meta && this.$route.meta.DataSingleBuilder || this.$route.meta && this.$route.meta.SubColEntryViewer){
                return 'SingleBuildTabs'
            }
            else if(this.$route.meta && this.$route.meta.ClassifiedListingBuilder){
                return 'ClassifiedTabs'
            }
            else if(this.$route.meta && this.$route.meta.WikiListingBuilder){
                return 'WikiTabs'
            }
            else{
                return 'PageTabs'
            }
        //return this.$route.meta && this.$route.meta.DataSingleBuilder || this.$route.meta && this.$route.meta.SubColEntryViewer? 'SingleBuildTabs' : 'PageTabs'
    },		
        PageTabs(){
            return this.EditedPage ? this.EditedPage[this.PageTabsPropName] : []
        },
      EditedPage(){
            return this.$store.state.EditedPage
        },
      MiniView(){
            return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs
        },
        ActiveGroup(){
          return this.$store.state.ActiveGroup
        },
        IMGProp(){
          return this.$store.state.IMGProp
        },
        EditedTab(){
          return this.$store.state.EditedTab
        },
        UseGroupAssets(){
            return this.$route.name === 'GroupPageBuilder' && this.ActiveGroup || this.$route.name === 'GroupPageEditor' && this.ActiveGroup
        },
        GalleryAssets(){
          return this.$store.state.GalleryAssets
        },
        GalleryLibraries(){
          return this.$store.state.GalleryLibraries
        },
        ImageCols(){
          if(this.$vuetify.breakpoint.xs){
            return 12
          }
          else if(this.$vuetify.breakpoint.sm){
            return 6
          }
          else if(this.$vuetify.breakpoint.md){
            return 4
          }
          else if(this.$vuetify.breakpoint.lg){
            return 3
          }
          else if(this.$vuetify.breakpoint.xl){
            return 2
          }
        },
        
        userLoggedIn () {
        return this.$store.getters.user
        },
        userIsAdmin () {
            return this.$store.state.IsAdmin
        },
        WindowHeight(){
            return window.innerHeight
        },
        SocialItemInteractMethod(){
        return this.$store.state.SocialItemInteractMethod
        },
        SocialItemInteractMethodProp(){
            return this.$store.state.SocialItemInteractMethodProp
        },
        RouteObj(){
          return this.$route
        },
        PluginsPath(){
        return this.$store.state.PluginsPath
      },
      UnPaidPlugins(){
          return this.RAPlugins.filter(plug => {
              return this.PluginDataBase[plug.id] && !this.PluginDataBase[plug.id].Active
          })
      },
      PurchasablePlugins(){
          return this.RAPlugins.filter(plug => {
              return !this.PluginDataBase[plug.id] && plug.Strictly_One_Purchase || !plug.Strictly_One_Purchase
          })
      },
        RAPlugins(){
          return this.$store.state.RAPlugins
        },
    },
    watch: {
  
      AppBuilderGuideElementid: {
            handler: function(newvalue, oldvalue) {
                if(oldvalue !== newvalue && typeof newvalue !== 'undefined'){
                  console.log(newvalue)
                    this.HelperParentElement = document.getElementById(newvalue)
                    console.log(this.HelperParentElement)
                    this.getOffset(this.HelperParentElement)
                }
            },deep: true
        },
      MiniView(value){
            if(value){
                this.TurnoffSiteDialog()
            }
            else{
                this.TurnonSiteDialog()
            }
        },
      RouteObj: {
            handler: function(newvalue, oldvalue) {
                if(oldvalue !== newvalue){
                    this.SelectBuilder()
                }
            },deep: true
        },
        EditedPage: {
            handler: function(newvalue, oldvalue) {
                if(oldvalue !== newvalue){
                   this.AssignPage()
                }
            },deep: true
        },
        BuilderView:{
         handler: function(oldvalue, newvalue) {
          if(oldvalue !== newvalue){
            this.SelectBuilder()
          }
         },deep: true
      },
        SocialItemInteractMethod(v){   
        let acceptedmethods = ['PurchasePlugin']   
        if(v && acceptedmethods.includes(v)){
          if(this.SocialItemInteractMethodProp){
            this[this.SocialItemInteractMethod](this.SocialItemInteractMethodProp)
            if(this.SocialItemInteractMethod === 'ActivateSelectedElement'){
              this.SingleRecordNavMenuItem = ''
            }
            this.$store.commit('SetSocialItemInteractMethodProp','') 
            this.$store.commit('SetSocialItemInteractMethod','')
          }
          else{ 
            this[this.SocialItemInteractMethod]()
            this.$store.commit('SetSocialItemInteractMethodProp','') 
            this.$store.commit('SetSocialItemInteractMethod','')
          }          
        }
      },
    },
    created(){
      this.SelectBuilder()
      if(this.MiniView){
          this.TurnoffSiteDialog()
      }	
      else{
          this.TurnonSiteDialog()
      }	
      window.onload = setTimeout(() => {
        if(this.AppBuilderGuideElementid){
         this.HelperParentElement = document.getElementById(this.AppBuilderGuideElementid)  
        }   
        console.log(this.HelperParentElement)
      }, 300);
    },
    methods:{
        IntranetViewToggle(boolean1,boolean2){
        if(boolean1){
          this.$store.commit('setSiteDialog',false)
        }        
        this.$emit('IntranetViewToggle',boolean1,boolean2)
      },
      SelectPage(Page){
        let page = this.ComputedSitePages.find(obj => obj.id === Page.id)
        this.SelectedPage = page
        //console.log(Page,page)
        this.EditOtherPage(this.SelectedPage)
      },
      PrepareNewApp(){
        this.$store.commit('setCustomProcessingDialogText','Preparing App')
        this.$store.commit('setCustomProcessingDialog',true)
        this.NewApp.id = this.NewApp.Name.split(' ').join('_')
        console.log(this.NewApp,this.InstallingTables)
        if(this.InstallingTables.length > 0){
          this.$store.commit('setCustomProcessingDialogText','Installing Tables')
          this.InstallingTables.map(table => {
            table.Primary_Appid = this.NewApp.id
            //ESSENTIALLY THIS IS WHERE IT FALLS FLAT BOB, APP INSTALLS MULTIPLE PLUGINS, NOT TABLES. WHAT WOULD THE PLUGIN BE NOW?
            table.Plugins = []
          })
          let tableplugins = this.NewApp.Plugins.filter(plug => {
            return plug.Installation_Tables && plug.Installation_Tables.length > 0
          })
          let totaltables = this.InstallingTables.length
          let counter = 0
          tableplugins.map((plug,plugindex) => {
               plug.Installation_Tables.map(table => {
                let tablematch = this.InstallingTables.find(obj => obj.PluginEntityid === table.id && obj.PluginInstanceIndex === table.PluginInstanceIndex)
                if(tablematch){
                table.id = tablematch.id
                table.DisplayName = tablematch.DisplayName  
                table.Entity_Type = tablematch.Entity_Type
                }                
                counter = counter-1+2
                if(counter === totaltables){
                  this.StoreNewApp()
                }
               })
          })       
        }
        else{
          this.StoreNewApp()
        }
      },
      StoreNewApp(){    
        //1. minimize any present installation tables properties on NewApp.Plugins, to just id,DisplayName
        //2. determine installation tables, prepare for subcol prop removal, whilst subcol adding. precedde step 3 with complete and final adding of all tables
        //3. prepare plugins to basic minim props
        //4. add app, then add plugins
        //FINALLY Remaini_vouchers just stupid on this level, and "apps" prop was prior all this so removed it
        this.$store.commit('setCustomProcessingDialogText','Finalizing')
        let vm = this   
        console.log(this.NewApp,this.InstallingTables)
        let NewAppObject = Object.assign({},this.NewApp)
        NewAppObject.Active = true
        let Plugins = NewAppObject.Plugins.map(plug => {
          let plugobj = {
              id: plug.id,
              Name: plug.Name,
              Module_Category: plug.Module_Category,
              Active: true
            }
            if(plug.Installation_Tables){
              plugobj.Installation_Tables = plug.Installation_Tables.map(table => {
                let tableobj = {
                  id: table.id,
                  DisplayName: table.DisplayName,
                  Entity_Type: table.Entity_Type
                }
                return tableobj
              })
            }
            return plugobj
        })
        delete NewAppObject.Plugins
        console.log(NewAppObject,Plugins)
        let tables = JSON.parse(JSON.stringify(this.InstallingTables))
        let totaltables = tables.length
        if(totaltables === 0){
          this.FinalizeNewApp(NewAppObject,Plugins)
        }
        else{
          tables.map((preppedtable,tableindex)=> {
               let tableobj = Object.assign({},preppedtable)
                  this.InstallingTables[tableindex] = {id: tableobj.id,DisplayName: tableobj.DisplayName}
                  let subcols = ['AllFields','SubCollections','EntityProcesses','DigitizedForms','DocumentRegisters','Galleries','automations']
                  let finaltable = Object.assign({},tableobj)
                  delete finaltable.id
                  subcols.map(prop => {
                    delete finaltable[prop]
                  })
                  finaltable.Created_On = new Date()
                  finaltable.Modified_On = new Date()
                  finaltable.Created_By = {Name: vm.userLoggedIn.Name,Surname: vm.userLoggedIn.Surname,Full_Name: vm.userLoggedIn.Full_Name,id: vm.userLoggedIn.id},
                  finaltable.Created_Byid = vm.userLoggedIn.id,
                  finaltable.Modified_By = {Name: vm.userLoggedIn.Name,Surname: vm.userLoggedIn.Surname,Full_Name: vm.userLoggedIn.Full_Name,id: vm.userLoggedIn.id},
                  finaltable.Modified_Byid = vm.userLoggedIn.id
                  //console.log(tableobj.id,finaltable)
                  vm.AddTable(tableobj,finaltable).then(newdoc => {
                   if(finaltable.Entity_Type.Name === 'Classified Listing'){
                      let clsfdentity = {
                        SingleName: finaltable.SingleName,
                        PublishType: 'Public',
                        ClassifiedTabs: []
                      }
                      console.log(clsfdentity)
                      db.collection('SystemConfig').doc(process.env.VUE_APP_RA_SYSTEM_ID).collection('classifiedentities').doc(finaltable.DisplayName.split(' ').join('_')).set(clsfdentity)
                    }
                    let subcolentries = subcols.map(subcol => {
                      return tableobj[subcol]
                    }).flat()
                    let totalsubcolentries = subcolentries.length
                    let entrycounter = 0
                    subcols.map((subcol,subcolindex) => {                      
                      tableobj[subcol].map(subcolentry => {
                        vm.AddTableSubCol(tableobj,subcol,subcolentry).then(newsubcoldoc => {
                        entrycounter = entrycounter-1+2
                          if(tableindex-1+2 === totaltables && entrycounter === totalsubcolentries){
                            this.FinalizeNewApp(NewAppObject,Plugins)
                          }
                        })
                      })
                    })
                  })
                
                })
        }
      },
      AddTableSubCol(tableobj,subcol,subcolentry){
        let vm = this
        return new Promise(function(resolve, reject) {
        if(vm.RADB){
          vm.RADB.collection('systems').doc(process.env.VUE_APP_RA_SYSTEM_ID).collection('entities').doc(tableobj.id).collection(subcol).doc(subcolentry.id).set(subcolentry).then(ranewdoc => {
            db.collection('SystemConfig').doc(process.env.VUE_APP_RA_SYSTEM_ID).collection('entities').doc(tableobj.id).collection(subcol).doc(subcolentry.id).set(subcolentry).then(newsubcoldoc => {
              resolve(newsubcoldoc)
            })
          })          
        }
        else{
           db.collection('SystemConfig').doc(process.env.VUE_APP_RA_SYSTEM_ID).collection('entities').doc(tableobj.id).collection(subcol).doc(subcolentry.id).set(subcolentry).then(newsubcoldoc => {
            resolve(newsubcoldoc)
          })
        }
        })
      },
      AddTable(tableobj,finaltable){
        let vm = this
        return new Promise(function(resolve, reject) {
        if(vm.RADB){
          vm.RADB.collection('systems').doc(process.env.VUE_APP_RA_SYSTEM_ID).collection('entities').doc(tableobj.id).set(finaltable).then(ranewdoc => {
            db.collection('SystemConfig').doc(process.env.VUE_APP_RA_SYSTEM_ID).collection('entities').doc(tableobj.id).set(finaltable).then(newdoc => {
              resolve(newdoc)
            })
          })          
        }
        else{
          db.collection('SystemConfig').doc(process.env.VUE_APP_RA_SYSTEM_ID).collection('entities').doc(tableobj.id).set(finaltable).then(newdoc => {
            resolve(newdoc)
          })
        }
        })
      },
      FinalizeNewApp(NewAppObject,Plugins){
        let newappid = this.NewApp.id
        let pluginslength = Plugins.length
        this.AppsPath.doc(this.NewApp.id).set(NewAppObject).then(newappdoc => {
          if(pluginslength === 0){
            this.$router.push('/App/'+this.NewApp.id)
            this.ToggleNewAppDialog()
          }
          else{
            Plugins.map((plugin,plugindex) => {
              //console.log(this.NewApp.id,plugin.id)
              this.AppsPath.doc(this.NewApp.id).collection('plugins').doc(plugin.id).set(plugin).then(newplugdoc => {               
              if(plugin.id === 'Warehouse_&_Products'){
                let articleent = plugin.Installation_Tables.find(obj => obj.Entity_Type.Name === 'Inventory Article')
                let storprodent = plugin.Installation_Tables.find(obj => obj.Entity_Type.Name === 'Store Product')
                this.UpdateAppProp('Article_Master',articleent.id,newappid)
                this.UpdateAppProp('Warehouse_Product_Master',storprodent.id,newappid)
                 if(plugindex-1+2 === pluginslength){
                  this.$router.push('/App/'+this.NewApp.id)
                  this.ToggleNewAppDialog()
                }
              }
              else if(plugin.id === 'Online_Store'){
                let storordent = plugin.Installation_Tables.find(obj => obj.Entity_Type.Name === 'Store Order')
                this.UpdateAppProp('Store_Order_Master',storordent.id,newappid)
                let SONumberAuto = {
                  id: storordent.id+'_SO_Number',
                  Digits: 6,
                  DisplayName: 'SO Number',
                  Last_Numbers: [],
                  Last_Number: 0,
                  Last_Value: '',
                  Name: 'SO_Number',
                  NumberingString: '0',
                  Type: 'AutoNumber Field',
                  Suffixes: [],
                  Prefixes: [
                    {Prefix_Value: 'SO-',Type: 'Standard'}
                  ]
                }
                db.collection('SystemConfig').doc(process.env.VUE_APP_RA_SYSTEM_ID).collection('AutoNumbers').doc(SONumberAuto.id).set(SONumberAuto)
                let invartent = this.SystemEntities.find(obj => obj.id === this.NewApp.Article_Master)
                if(vm.RADB){
                  vm.RADB.collection('systems').doc(process.env.VUE_APP_RA_SYSTEM_ID).collection('entities').doc(this.NewApp.Article_Master).update({
                  Has_Store: true,
                  Cart_Entity: storordent.id,
                  NavList: [],
                  ListPrimaryField: invartent.AllFields.find(obj => obj.id === 'Product_Group')
                }).then(radocupdate => {
                  db.collection('SystemConfig').doc(process.env.VUE_APP_RA_SYSTEM_ID).collection('entities').doc(this.NewApp.Article_Master).update({
                  Has_Store: true,
                  Cart_Entity: storordent.id,
                  NavList: [],
                  ListPrimaryField: invartent.AllFields.find(obj => obj.id === 'Product_Group')
                })
                })
                }
                else{
                 db.collection('SystemConfig').doc(process.env.VUE_APP_RA_SYSTEM_ID).collection('entities').doc(this.NewApp.Article_Master).update({
                  Has_Store: true,
                  Cart_Entity: storordent.id,
                  NavList: [],
                  ListPrimaryField: invartent.AllFields.find(obj => obj.id === 'Product_Group')
                }) 
                }
                
                if(plugindex-1+2 === pluginslength){
                  this.$router.push('/App/'+this.NewApp.id)
                  this.ToggleNewAppDialog()
                }
              }
              else if(plugindex-1+2 === pluginslength){
                  this.$router.push('/App/'+this.NewApp.id)
                  this.ToggleNewAppDialog()
                }
              })
            })
          }
        })
      },
      UpdateAppProp(prop,value,appid){
        this.AppsPath.doc(appid).update({
          [prop]: value
        })
      },
      PickPlugin(plug){
        console.log(plug,this.NewApp)
        if(this.newappstep === 3){
          let plugincluded = true
          let plugobj = this.NewApp.Plugins.find(obj => obj.id === plug.id)
          if(!plugobj){
            plugobj = Object.assign({},plug)
            if(plug.Installation_Tables && plug.Installation_Tables.length > 0){
             plugobj.Installation_Tables = [] 
            }            
            this.NewApp.Plugins.push(Object.assign({},plug))
            plugincluded = false
          }
          //plug.Disabled = true
          if(plugobj.Installation_Tables){
            console.log(plugobj,plugobj.Installation_Tables)
            let tables = JSON.parse(JSON.stringify(plug.Installation_Tables))
            //console.log(plugincluded,tables,plugobj.Installation_Tables)
            this.$store.commit("setCustomProcessingDialogText","Processing")
            this.$store.commit('setCustomProcessingDialog',true)
            if(this.RADB){
                entcol = this.RADB.collection('entities')
              }
              else{
                entcol = db.collection('entities')
              }
              this.PreparePluginEntities(entcol,tables).then(InstallingTables => {
              //console.log(InstallingTables)
              this.ImmediateTables = []
            this.ImmediateTables = InstallingTables.map(table => {
              let appearances = plugobj.Installation_Tables.filter(plugtable => {
                return plugtable.PluginEntityid === table.PluginEntityid
              })
              table.PluginInstanceIndex = appearances.length
              return table
            })
            //console.log(this.ImmediateTables)
            plugobj = this.NewApp.Plugins.find(obj => obj.id === plug.id)
            if(plugincluded){
              plugobj.Installation_Tables = plugobj.Installation_Tables.concat(InstallingTables)
            }
            else{
              plugobj.Installation_Tables = InstallingTables
            }  
            //console.log(plugobj.Installation_Tables)          
            this.InstallingTables = plugobj.Installation_Tables
            this.$store.commit('setCustomProcessingDialog',false)
            this.$store.commit("setCustomProcessingDialogText","")
            if(this.ConfigRequiredImmediateTables.length > 0){
              this.NextStep = 3
              this.newappstep = 4
            }  
            })          
          }          
        }
        else if(this.newappstep === 2){
          this.NewApp.AppTemplate = {id: plug.id, Name: plug.Name}
          this.NewApp.AppTemplateid = plug.id
          this.AdvanceNewappDialog()
          //Plugins.push(plug)
        }
        console.log(this.NewApp)
      },
      RAPluginsMatched(categorymatches){
         let finalcategories = categorymatches.map(cat => {
          return cat.split(' & ')
        }).flat()
        return this.RAPlugins.filter(plug => {
          let plugcat = plug.Module_Category.Name.split(' & ').flat()
          return finalcategories.some(r=> plugcat.includes(r))
          //|| plug.Module_Category.Name === 'General'
        }).filter(item => {
            if(this.DataSingleBuilder){
                return item.Exclusive_as_Extension
            }
            else{
                return item
            }
        }).filter(plug => {
          let newappplugins = this.NewApp.Plugins.map(plug => {
            return plug.id
          })
        // .map(plug => {
        //   //because we mutate and make it "disbaled selected"
        //   let plugobj = Object.assign({},plug)
        //   return plugobj
        // })
        
          //console.log(newappplugins)
          return !newappplugins.includes(plug.id) && plug.Strictly_One_Purchase || !plug.Strictly_One_Purchase
        })
      },
      ToggleNewAppDialog(){
        // this.NewApp
        this.NewAppDialog = !this.NewAppDialog
        if(!this.NewAppDialog){
          this.NewApp = Object.assign({},this.DefaultNewApp)
          this.NextStep = 1
          this.InstallingTables = []
        }
        else {
          this.newappstep = this.NextStep
        }
        this.$store.commit('setCustomProcessingDialog',false)
        this.$store.commit('setCustomProcessingDialogText','')
      },
      AdvanceNewappDialog(){
        
        if(this.newappstep !== 4 && this.newappstep !== 5){
          this.newappstep++
        }
        // else if(this.newappstep === 1){
        //   this.newappstep = 4
        // }
        else if(this.newappstep === 4){
          let plugintables = this.NewApp.Plugins.filter(plug => {
            return plug.Installation_Tables
          })
          if(plugintables && plugintables.length > 0){
           this.FixTableNaming().then(result => {
            this.FixLookupReferences().then(result => {
              if(this.NextStep === 4){
                this.NextStep = 5
              }
              this.newappstep = this.NextStep
              this.NextStep++
            })
          }) 
          }
          else{
             this.newappstep = this.NextStep
              this.NextStep++
          }
          
        }
        else if(this.newappstep === 5){
          this.FixTableNaming().then(result => {
            this.FixLookupReferences().then(result => {
              this.newappstep++
            })
          })
        }
        // else{
        //   this.newappstep++
        // }
      },
      getOffset(el) {
      const rect = el.getBoundingClientRect();
      let positionobj = {
        left: rect.left,
        // + window.scrollX,
        top: rect.top
        // + window.scrollY
      }
      this.HelpElmntLeft = positionobj.left
      this.HelpElmntTop = positionobj.top
      console.log(positionobj)
      //return positionobj
    },
      ProceedHelpder(){
        // this.$store.commit('setAppBuilderHelperActive',true)
        // this.$store.commit('setAppBuilderHelperStep',3)
        console.log('whether by side nav, plugins popup, of within the getting start page, here we need to showcase plugins that are "modules"')
      },
      AdvanceHelperMethod(tab){
        // if(this.AppBuilderHelperStep === 2 && this.NoActiveModule){
          let step = this.AppBuilderHelperStep-1+2
          this.HelpElmntLeft = ''
          this.HelpElmntTop = ''
          this.$store.commit('setAppBuilderHelperActive',false)
          setTimeout(() => {
            if(step === 2 || step === 3 && !this.NoActiveModule){
              this.$store.commit('setAppBuilderHelperActive',true)
              this.$store.commit('setAppBuilderHelperStep',step)
            }            
          }, 10); 
        // }
        
        
      },  
      ActionBtnMethod(tab){
        this[tab.ActionButtonMethod](tab)
      },
      FixTableNaming(){
        let vm = this
        return new Promise(function(resolve, reject) {
          vm.InstallingTables.map((table,tableindex)=> {
            let previousprimaryfieldid = table.RecordPrimaryField.Name
            let previousid = table.id
            if(previousprimaryfieldid !== table.Primary_Field_Name.split(' ').join('_')){
              console.log(previousprimaryfieldid,table.Primary_Field_Name.split(' ').join('_'))
              table.RecordPrimaryField.id = table.Primary_Field_Name.split(' ').join('_')
              table.RecordPrimaryField.Name = table.Primary_Field_Name.split(' ').join('_')
              table.RecordPrimaryField.DisplayName = table.Primary_Field_Name
              table.Primary_Field_Name = table.Primary_Field_Name.split(' ').join('_')
              table.id = table.DisplayName.split(' ').join('_')
              let fieldentry = table.AllFields.find(obj => obj.id === previousprimaryfieldid)
              fieldentry.id = table.Primary_Field_Name
              fieldentry.Name = table.Primary_Field_Name
              fieldentry.DisplayName = table.RecordPrimaryField.DisplayName
              table.SingleBuildTabs.map(tab => {
                if(tab.Elements){
                  tab.Elements.map(elmnt => {
                    if(elmnt.Fields){
                      let primfield = elmnt.Fields.find(obj => obj.id === previousprimaryfieldid)
                      if(primfield){
                       primfield.DisplayName = table.RecordPrimaryField.DisplayName
                       primfield.Name = table.Primary_Field_Name 
                      }                      
                    }
                  })
                }
              }) 
            }
            if(previousid !== table.DisplayName.split(' ').join('_')){
              table.id = table.DisplayName.split(' ').join('_')
            }            
             if(tableindex-1+2 === vm.InstallingTables.length){
              //console.log(Installation_Tables)
              resolve(vm.InstallingTables)
            }
          })
        })
      },
      FixLookupReferences(){
        let vm = this
        return new Promise(function(resolve, reject) {
          vm.InstallingTables.map((table,tableindex)=> {
            table.datasetsecuritystructure = table.Security_Structure.Name
            if(table.datasetsecuritystructure === 'Business Unit'){
              let bufield = {id: 'Business_Unit',Name: 'Business_Unit', DisplayName: 'Business Unit', Type: 'Lookup',LookupFieldName: 'Name',RelatedBuildID: 'Business_Units',RelatedLocation: 'Business Unit', RelatedRecord: 'Business Units',Primary: false, Created: true, IsMandatory: true, IsHeader: true,HeaderIndex: 1, UsedonCompForm: true, UsedonForm: true,  SystemRequired: true}
              let ownerfield = {id: 'Owner',Name: 'Owner', DisplayName: 'Owner', Type: 'Lookup',LookupFieldName: 'Full_Name',RelatedBuildID: 'Users',RelatedLocation: 'User', RelatedRecord: 'Users',Primary: false, Created: true, IsMandatory: true, IsHeader: true,HeaderIndex: 2, UsedonCompForm: true, UsedonForm: true,  SystemRequired: true}
              let bufieldon = table.AllFields.find(obj => obj.id === bufield.id)
              if(!bufieldon){
                table.AllFields.push(bufield)
              }
              let ownerfieldon = table.AllFields.find(obj => obj.id === ownerfield.id)
              if(!ownerfieldon){
                table.AllFields.push(ownerfield)
              }
            }
            let lookupfields = table.AllFields.filter(field => {
              return field.Type === 'Lookup'
            })
            lookupfields.map(lufield => {
              let entity = vm.InstallingTables.find(obj => obj.PluginEntityid === lufield.RelatedBuildID)
              if(entity && !entity.System_Required){
                //while there is a default template for each entity, if the entity is "System_Reqruied" the id, Name, and sec strucure will be readonly
                  //therefore no need to change the id either.
                  //we could have separated Icon. Sec Structure, Name, id, and primary field. but system_reuired truly means all of that
                lufield.LookupFieldName = entity.Primary_Field_Name.split(' ').join('_')
                lufield.RelatedLocation = entity.SingleName
                lufield.RelatedRecord = entity.DisplayName
                lufield.RelatedBuildID = entity.id 
              }              
            })
            let lusubcols = table.SubCollections.filter(subcol => {
              return subcol.LookupBuilds
            })
            lusubcols.map(subcol => {
              subcol.LookupBuilds.map(lubuild => {
                let entity = vm.InstallingTables.find(obj => obj.PluginEntityid === lubuild.id)
                if(entity && !entity.System_Required){
                  lubuild.single = entity.SingleName.split(' ').join('')
                  lubuild.tempname = entity.SingleName
                  lubuild.temppluralname = entity.DisplayName
                  lubuild.recordprimaryfield = entity.RecordPrimaryField
                  lubuild.identifier = entity.Primary_Field_Name
                  lubuild.id = entity.id
                  //actually Headers and LinkedFields as well...
                }                
              })
            })
            if(tableindex-1+2 === vm.InstallingTables.length){
              resolve(vm.InstallingTables)
            }
          })
        })
      },
      PreparePluginEntities(query,entities){
         //so what if the plugin installs BA, but we already have BA? 
         let vm = this
         let tables = []
         let totaltables = entities.length
          return new Promise(function(resolve, reject) {
            entities.map((table,tableindex)=> {
                vm.GetAllEntityProps(query,table).then(tableobj => {
                  tables.push(tableobj)
                  if(tableindex-1+2 === totaltables){
                    resolve(tables)
                  }
                })
            })
          })
      },
      GetAllEntityProps(configdb,table){
        let vm = this
        // console.log('calling props')
        return new Promise(function(resolve, reject) {
          configdb.doc(table.id).get().then(tablensap => {
            let build = tablensap.data()
            build.id = table.id
            build.PluginEntityid = table.id
            vm.GetEntityAllFields(configdb,build).then(function(allfieldsresult) {
                if(allfieldsresult){
                  
                    // console.log(allfieldsresult)
                    vm.GetEntitySubCollections(configdb,build).then(function(subcolresult) {
                        // console.log(subcolresult)
                        
                    if(allfieldsresult && subcolresult){
                        vm.GetEntityProcesses(configdb,build).then(function(processesresult) {
                        // console.log(processesresult)
                        vm.GetDigitizedForms(configdb,build).then(function(formsresult) {
                            vm.GetDocumentRegisters(configdb,build).then(function(docregresult) {  
                                vm.GetGalleries(configdb,build).then(function(galleryres) {                          
                                vm.GetEntityAutomations(configdb,build).then(function(automationsresult) {
                                    //console.log(build)
                                    resolve(build)
                                    
                                
                                })
                                })
                                })
                        })
                        })
                    }
                    })
                }           
            })
          })        
        })
        },
    GetEntityAllFields(configdb,build){    
            // console.log('calling fields') 
            build.AllFields = []
                   
            let vm = this
            return new Promise(function(resolve, reject) {
                // console.log('attempting to get all fields for '+build.id,build.AllFields)
                //console.log(configdb.doc(build.id).collection('AllFields'))
            configdb.doc(build.id).collection('AllFields').onSnapshot(res => {
                let arraylength = res.docs.length
                if(arraylength === 0){
                    resolve('Method SystemEntities AllFields Finished for ' + build.AllFields.length)
                }
            const changes = res.docChanges();
            changes.forEach(change => {
                if (change.type === 'added') {
                build.AllFields.push({
                    ...change.doc.data(),
                    id: change.doc.id
                })
                }
                if(build.AllFields.length === arraylength){
                    
                resolve('Method SystemEntities AllFields Finished for ' + build.AllFields.length)
                }
                })
                })
            })
        },
        GetEntitySubCollections(configdb,build){     
            // console.log('calling SubCollections')
            build.SubCollections = []            
            let vm = this
            return new Promise(function(resolve, reject) {
                // console.log('attempting to get all fields for '+build.id,build.AllFields)
            configdb.doc(build.id).collection('SubCollections').onSnapshot(res => {
            let arraylength = res.docs.length
            if(arraylength === 0){
                    resolve('Method SystemEntities AllFields Finished for ' + build.SubCollections.length)
                }
            const changes = res.docChanges();
            changes.forEach(change => {
                if (change.type === 'added') {
                build.SubCollections.push({
                    ...change.doc.data(),
                    id: change.doc.id
                })
                }
                if(build.SubCollections.length === arraylength){
                    
                resolve('Method SystemEntities SubCollections Finished for ' + build.SubCollections.length)
                }
                
                })
                })
            })
        },
        GetEntityProcesses(configdb,build){    
            // console.log('calling fields') 
            build.EntityProcesses = []            
            let vm = this
            return new Promise(function(resolve, reject) {
                // console.log('attempting to get all fields for '+build.id,build.AllFields)
            configdb.doc(build.id).collection('EntityProcesses').where('Status','!=','InActive').onSnapshot(res => {
                let arraylength = res.docs.length
                if(arraylength === 0){
                    resolve('Method SystemEntities EntityProcesses Finished for ' + build.EntityProcesses.length)
                }
            const changes = res.docChanges();
            changes.forEach(change => {
                if (change.type === 'added') {
                build.EntityProcesses.push({
                    ...change.doc.data(),
                    id: change.doc.id
                })
                }
                if(build.EntityProcesses.length === arraylength){
                    
                resolve('Method SystemEntities EntityProcesses Finished for ' + build.EntityProcesses.length)
                }
                })
                })
            })
        },
        GetDigitizedForms(configdb,build){    
            // console.log('calling fields') 
            build.DigitizedForms = []            
            let vm = this
            return new Promise(function(resolve, reject) {
                // console.log('attempting to get all fields for '+build.id,build.AllFields)
            configdb.doc(build.id).collection('DigitizedForms').onSnapshot(res => {
                let arraylength = res.docs.length
                if(arraylength === 0){
                    resolve('Method SystemEntities DigitizedForms Finished for ' + build.DigitizedForms.length)
                }
            const changes = res.docChanges();
            changes.forEach(change => {
                if (change.type === 'added') {
                build.DigitizedForms.push({
                    ...change.doc.data(),
                    id: change.doc.id
                })
                }
                if(build.DigitizedForms.length === arraylength){
                    
                resolve('Method SystemEntities DigitizedForms Finished for ' + build.DigitizedForms.length)
                }
                })
                })
            })
        },
        GetDocumentRegisters(configdb,build){
            build.DocumentRegisters = []            
            let vm = this
            return new Promise(function(resolve, reject) {
                // console.log('attempting to get all fields for '+build.id,build.AllFields)
            configdb.doc(build.id).collection('DocumentRegisters').onSnapshot(res => {
                let arraylength = res.docs.length
                if(arraylength === 0){
                    resolve('Method SystemEntities DocumentRegisters Finished for ' + build.DocumentRegisters.length)
                }
            const changes = res.docChanges();
            changes.forEach(change => {
                if (change.type === 'added') {
                build.DocumentRegisters.push({
                    ...change.doc.data(),
                    id: change.doc.id
                })
                }
                if(build.DocumentRegisters.length === arraylength){
                    
                resolve('Method SystemEntities DocumentRegisters Finished for ' + build.DocumentRegisters.length)
                }
                })
                })
            })
        },
        GetGalleries(configdb,build){
            build.Galleries = []            
            let vm = this
            return new Promise(function(resolve, reject) {
                // console.log('attempting to get all fields for '+build.id,build.AllFields)
            configdb.doc(build.id).collection('Galleries').onSnapshot(res => {
                let arraylength = res.docs.length
                if(arraylength === 0){
                    resolve('Method SystemEntities Galleries Finished for ' + build.Galleries.length)
                }
            const changes = res.docChanges();
            changes.forEach(change => {
                if (change.type === 'added') {
                build.Galleries.push({
                    ...change.doc.data(),
                    id: change.doc.id
                })
                }
                if(build.Galleries.length === arraylength){
                    
                resolve('Method SystemEntities Galleries Finished for ' + build.Galleries.length)
                }
                })
                })
            })
        },
        GetEntityAutomations(configdb,build){    
            // console.log('calling fields') 
            build.automations = []            
            let vm = this
            return new Promise(function(resolve, reject) {
                // console.log('attempting to get all fields for '+build.id,build.AllFields)
            configdb.doc(build.id).collection('automations').onSnapshot(res => {
                let arraylength = res.docs.length
                if(arraylength === 0){
                    resolve('Method SystemEntities automations Finished for ' + build.automations.length)
                }
            const changes = res.docChanges();
            changes.forEach(change => {
                if (change.type === 'added') {
                build.automations.push({
                    ...change.doc.data(),
                    id: change.doc.id
                })
                }
                if(build.automations.length === arraylength){
                    
                resolve('Method SystemEntities automations Finished for ' + build.automations.length)
                }
                })
                })
            })
        },
      PurchasePlugin(pack){
        
        console.log(pack)
        pack.Plugins.map(plug => {
            let plugobj = {
              id: plug.id,
              Name: plug.Name,
              Module_Category: plug.Module_Category,
              Active: true
            }
            if(plug.Installation_Tables){
              if(this.RADB){
                entcol = this.RADB.collection('entities')
              }
              else{
                entcol = db.collection('entities')
              }
              this.PreparePluginEntities(entcol,plug.Installation_Tables).then(InstallingTables => {
                console.log(InstallingTables)
                this.InstallingTables = InstallingTables
                this.NewAppDialog = true
                this.NewApp = plugobj
                this.$store.commit('SetAlertSound','success_sound')
                this.$store.commit('EmitMarketDialog',false)
                this.$store.commit('EmitMarketDialogObject','')
                this.$store.commit('EmitMarketDialogOptions',[])
                this.$store.commit('EmitMarketDialogType','')
                this.$store.commit('EmitMarketDialogDescription','')
                this.$store.commit('EmitMarketDialogTitle','')        
                this.$store.commit('EmitMarketDialogAvatar','')
                console.log(this.InstallingTables,plugobj)
              })              
            }
            else{
              this.PluginsPath.doc(plug.id).set(plugobj).then(obj => {
                this.$store.commit('SetAlertSound','success_sound')
                this.$store.commit('EmitMarketDialog',false)
                this.$store.commit('EmitMarketDialogObject','')
                this.$store.commit('EmitMarketDialogOptions',[])
                this.$store.commit('EmitMarketDialogType','')
                this.$store.commit('EmitMarketDialogDescription','')
                this.$store.commit('EmitMarketDialogTitle','')        
                this.$store.commit('EmitMarketDialogAvatar','')
                this.$store.commit('EmitMarketDialogInteractMethod','PurchasePlugin')
                if(plugobj.id === 'Member_Groups'){
                  this.DefaultMemberGroup.Created_By = this.CurrentUserProps	
                  this.DefaultMemberGroup.Created_Byid = this.CurrentUserProps.id		
                  this.DefaultMemberGroup.Created_On = new Date()
                  this.DefaultMemberGroup.Modified_By = this.CurrentUserProps	
                  this.DefaultMemberGroup.Modified_Byid = this.CurrentUserProps.id	
                  this.DefaultMemberGroup.Modified_On = new Date()
                  this.DefaultMemberGroup.Status = this.DefaultStatusField.DefaultOption
                  this.DefaultMemberGroup.Status_Reason = this.DefaultStatusField.DefaultLevel2Option
                  db.collection('membergroups').doc(this.DefaultMemberGroup.Name.split(' ').join('_')).set(this.DefaultMemberGroup).then(admindoc => {
                    db.collection('userroles').doc(this.CurrentUserProps.id).update({
                      MemberGroup: {Name: this.DefaultMemberGroup.Name, id: this.DefaultMemberGroup.Name.split(' ').join('_')},
                      MemberGroupid: this.DefaultMemberGroup.Name.split(' ').join('_')
                    })
                  })
                }
              })
            }
            console.log(plugobj)
            
        })
      },
      ToggleSiteDialog(){
            this.$store.commit('setSiteDialog',!this.SiteDialog)
        },
        TurnoffSiteDialog(){
            this.$store.commit('setSiteDialog',false)
        },
        TurnonSiteDialog(){
            this.$store.commit('setSiteDialog',true)
        },
      ToggleAppDarkMode(){
      this.$emit('ToggleAppDarkMode',!this.$vuetify.theme.dark)
    },
      SetColorstoSystemColors(System){
            this.$emit('SetColorstoSystemColors',System)
        },
      AssignSocialItemInteractMethod(item,SecondProp){
        //console.log('AssignSocialItemInteractMethod',item,SecondProp)
        this.$store.commit('SetSocialItemInteractMethodProp','') 
        this.$store.commit('SetSocialItemInteractMethod','')
        if(SecondProp){
            this.$store.commit('SetSocialItemInteractMethodProp',SecondProp) 
            this.$store.commit('SetSocialItemInteractMethod',item)
        }
        else if(item){
            this.$store.commit('SetSocialItemInteractMethod',item)
        }
        },
      AssignPage(){
         this.SelectedPage = this.EditedPage
      },
      SelectBuilder(){        
        this.SelectedBuilder = this.BuilderView
      },
      CheckBuilderRoute(){        
        // if(this.IsGroupView && this.SelectedBuilder && this.SelectedBuilder.Name !== 'Website Builder'){
        //   this.$router.push('/Group/Edit/'+this.GroupID)
        // }
        //okay actually it is in here. I have to have default routes my thoughts being..if GroupView it's either gorup edit or..well group edit
        //now I could go and make it quite "simple" for myself here and push to systemconfig always but ahve you seen teh delay here? No I need to understand do I have public pages or social pages and if I do push to them, if not etc.
        let relevantroute = ''
        if(this.SelectedBuilder.Name === 'Website Builder' || this.SelectedBuilder.Name === 'Social Network Builder'){
          //alert('eyeyey')
          if(this.IsGroupView && this.SelectedBuilder.Name === 'Website Builder'){
            relevantroute = this.ComputedSitePages[0]
            if(relevantroute){
              this.$router.push('/Group-PageEditor/'+this.GroupID+'/'+relevantroute.id)
            }
            else{
              this.$router.push('/Group/Edit/'+this.GroupID)
            }
          }
          else if(this.IsGroupView){
            this.$router.push('/Group/Edit/'+this.GroupID)
          }
          else{
            if(this.SelectedBuilder.Name === 'Website Builder'){
              relevantroute = this.SitePages.find(obj => obj.PublishType === 'Public')
            }
            else{
              //at this stage the issue is, if we push to a community page we lose the social component toggle
              //because it's within system config that the tabs exist to set general social comp settings
              relevantroute = this.SitePages.find(obj => obj.PublishType === 'Members Only')
            }
            if(relevantroute){
              this.$router.push('/PageEditor/'+relevantroute.id)
            }
            else{
              this.$router.push('/SystemConfig/'+process.env.VUE_APP_RA_SYSTEM_ID)
            }
          }
        }
        else if(this.SelectedBuilder.Name === 'Documentation Builder'){
          let doclib = this.DocumentationLibraries[0]
          let path = '/DocumentationLibraryEditor/'+doclib.id+'/'+doclib.FirstPageName.split(' ').join('-')
          if(this.$route.path !== path){
                this.$router.push(path)
            }
          //alert('yay')
        }
        else if(this.SelectedBuilder.Name === 'Suite Builder'){
          let path = '/Getting-Started'
          if(this.$route.path !== path){
                this.$router.push(path)
            }
          //alert('yay')
        }
        else if(this.SelectedBuilder.Name === 'App Builder'){
          console.log('yay')
        }
        
        else{
          //okay yeah think about it, if we toggle to dbview?
          if(this.IsGroupView){
            this.$router.push('/Group/Edit/'+this.GroupID)
          }
          else{
           // this.$router.push('/SystemConfig/'+process.env.VUE_APP_RA_SYSTEM_ID)
           let path = '/Getting-Started'
          if(this.$route.path !== path){
                this.$router.push(path)
            }
          }
        }
        this.$store.commit('setBuilderView',this.SelectedBuilder)
      },
      EditOtherPage(SelectedPage){
        //console.log(SelectedPage)
       if(this.IsGroupView){
            this.$router.push('/Group-PageEditor/'+this.GroupID+'/'+SelectedPage.id)
        }
        else{
          //EditedPage vs SelectedPage for builder select
            this.$router.push('/PageEditor/'+SelectedPage.id)
            this.$store.commit('setEditedPage','')
            //better but still annoying. Should go to the very first in the array of pages, and if none, then systemconfig is the go by sorry but true
        }
      },
      EditOtherApp(SelectedApp){
        this.$router.push('/App/'+SelectedApp.id)
        //this.$store.commit('setActiveSuiteApp',SelectedApp)
      },
      AddPageAsFavorite(){
      let routeitem = this.$router.options.routes.find(obj => obj.name === 'myprofile')
      //console.log("routeitem",routeitem)
      //console.log(this.$route.meta)
      let path = this.$route.path
      if(this.userLoggedIn.FavoriteLinks){
      let pathcheck = this.userLoggedIn.FavoriteLinks.find(obj => obj.Path === path)
        if(pathcheck){
          confirm('This item is already a favorite. Would you like to remove it from Favorites?') && this.RemoveFavorite(pathcheck)
        }
        else{
        let display = ''
        
        if(this.$route.params.id){
          this.RecordName = prompt("Please confirm a name for the favorite", this.CurrentRecordName)
          if (this.RecordName != '') {
            this.StoreFavorite(this.RecordName,path)
          }
          
        }
        else if(this.$route.params.slug){
          display = this.$route.params.slug+ '('+path.split('/')[1]+')'
          this.RecordName = prompt("Please confirm a name for the favorite", display)
          if (this.RecordName != '') {
            this.StoreFavorite(this.RecordName,path)
          }
        }
        else{
          display = path.replace('/','')
          this.RecordName = prompt("Please confirm a name for the favorite", display)
          if (this.RecordName != '') {
            this.StoreFavorite(this.RecordName,path)
          }
        }
        
        }
      }
      else{
        let display = ''
      if(this.$route.params.id){
          this.RecordName = prompt("Please confirm a name for the favorite", this.CurrentRecordName)
          if (this.RecordName != '') {
            this.StoreFavorite(this.RecordName,path)
          }
          
        }
        else if(this.$route.params.slug){
          display = this.$route.params.slug+ '('+path.split('/')[1]+')'
          this.RecordName = prompt("Please confirm a name for the favorite", display)
          if (this.RecordName != '') {
            this.StoreFavorite(this.RecordName,path)
          }
        }
        else{
          display = path.replace('/','')
          this.RecordName = prompt("Please confirm a name for the favorite", display)
          if (this.RecordName != '') {
            this.StoreFavorite(this.RecordName,path)
          }
        }      
      }
      
      // this.userLoggedIn.FavoriteLinks.find
    },
    StoreFavorite(display,path){
      let FavoriteLinks = []
        if(this.userLoggedIn.FavoriteLinks){
          FavoriteLinks = this.userLoggedIn.FavoriteLinks
        } 
        FavoriteLinks.push({
          DisplayName: display,
          Path: path
        })
        db.collection('users').doc(this.userLoggedIn.id).update({
          FavoriteLinks: FavoriteLinks
        })
    },
      
    }
}
</script>

<style>

</style>



